import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

import { css } from "@emotion/react"

import { useBreakpoint } from "gatsby-plugin-breakpoints"

import { fontSize, globalColors } from "../components/css-functions"
import SEO from "../components/seo"
import Image from "../components/image"
import Layout from "../components/layout"

import TopBg from "../components/top-bg"
import TopNewsList from "../components/top-news-list"

export default () => {

  const bp = useBreakpoint()

  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            menuLinks {
              link
              name
            }
          }
        }
      }
    `
  )

  const style = {
    content: css`
      width: 100%;
      height: ${ bp.isTablet && 'calc( 100vh - 100px )' };
      min-height: ${ bp.isTablet ? '768px' : '320px' };
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    `,
    logo: css`
      margin-top: ${ bp.isTablet ? '128px' : '64px' };
      width: ${bp.isTablet ? '270px' : '180px'};
      height: ${bp.isTablet ? '60px' : '40px'};
    `,
    list: css`
      margin-top: ${bp.isTablet ? '64px' : '32px'};
      display: grid;
      grid-template-columns: repeat(5, auto);
    `,
    listItem: css`
      padding: ${bp.isTablet ? '0 24px' : '0 16px'};
      writing-mode: vertical-rl;
      position: relative;
      &:not(:last-child)::after {
        content: "";
        display: block;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: 1px;
        height: 32px;
        background-color: ${globalColors.white};
      }
    `,
    link: css`
      display: flex;
      justify-content: space-between;
      color: ${globalColors.white};
      ${bp.isTablet ? fontSize(20) : fontSize(13)}
      font-weight: 700;
      letter-spacing: 0.5em;
      text-align: justify;
      text-align-last: justify;
      &:visited {
        color: ${globalColors.white};
      }
    `,
    newsWrapper: css`
      margin: auto 0 24px;
      padding-top: 64px;
    `,
  }

  return (
    <Layout>
      <SEO title="トップ" />
      <TopBg />
      <section css={ style.content }>
        <h1 css={style.logo}>
          <Image
            filename="topLogo.png"
            fadeIn={false}
            alt="細川流盆石"
          />
        </h1>
        <ul css={style.list}>
          {data.site.siteMetadata.menuLinks.map((item) => (
            <li
              key={item.name}
              css={style.listItem}
            >
              <Link
                to={item.link}
                css={style.link}
              >
                {item.name.split('').map((char) => (
                  <span key={char}>{char}</span>
                ))}
              </Link>
            </li>
          ))}
        </ul>
        { bp.isTablet &&
          <div css={ style.newsWrapper }>
            <TopNewsList />
          </div>
        }
      </section>
    </Layout>
  )
}
